import styled from '@emotion/styled';
import { MOBILE_QRY } from '~/config';
import Text from './Text';
import DesktopBanner from './DesktopBanner';
import { useIsDesktop } from '~/hooks/useIsDesktop';

// import { useMediaQuery } from 'react-responsive';
// import { changeSidebar } from '~/actions';
// import MenuIcon from '~/icons/MenuIcon';

// import { ADD_INVOICE_ROUTE } from '~/constants/routes';
// import { useLocation } from 'react-router-dom';
// import { useDispatch } from '~/store';

// const HamburgerButton = styled.button`
//   background: none;
//   border: none;
//   cursor: pointer;
// `;

const MainWrapper = styled.header`
  background: var(--white);
  padding-top: env(safe-area-inset-top);
  position: sticky;
  top: 0;
  z-index: 99;
`;

const HeaderWrapper = styled.div`
  height: 60px;
  z-index: 200;
  border-bottom: 1px solid var(--border1);
  padding: 0 14px;
  background: var(--white);

  ${MOBILE_QRY} {
    padding: 0 34px;
    height: 70px;
  }
`;

interface IHeaderProps {
  headerText: string;
  rightJsx?: any;
}

export default function Header({ headerText, rightJsx }: IHeaderProps) {
  const isDesktop = useIsDesktop();
  // const dispatch = useDispatch();
  // const location = useLocation();
  // function onOpenSidebarModal() {
  //   dispatch(changeSidebar(true));
  // }

  // const HAMBURGER_EXCLUDED_ROUTES = [ADD_INVOICE_ROUTE];
  // const isHamburgerExcluded = HAMBURGER_EXCLUDED_ROUTES.includes(location.pathname);

  return (
    <MainWrapper>
      <DesktopBanner />
      <HeaderWrapper data-component-name="Header" className="center space-between">
        <Text size={isDesktop ? 'md' : 'smd'} className="bold">
          {headerText}
        </Text>

        <div className="rightjsx">{rightJsx ? rightJsx : null}</div>

        {/* {isDesktop ? (
          <div className="rightjsx">{rightJsx ? rightJsx : null}</div>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            {rightJsx ? rightJsx : null}
            {!isHamburgerExcluded && (
              <HamburgerButton onClick={onOpenSidebarModal} aria-label="Open menu">
                <MenuIcon height={32} />
              </HamburgerButton>
            )}
          </div>
        )} */}
      </HeaderWrapper>
    </MainWrapper>
  );
}
